import fallbackImg from "../../assets/user.png"; // Import the fallback image

export const userColumns = [
  {
    field: "id",
    headerName: "ID",
    width: 200,
  },
  {
    field: "imageUrl",
    headerName: "Image",
    width: 30,
    renderCell: (params) => {
      const imgSrc = params.row.imageUrl || fallbackImg; // Use fallback image if img is null
      return (
        <div className="cellWithImg">
          <img
            className="cellImg"
            src={imgSrc}
            alt="avatar"
            onError={(e) => (e.target.src = fallbackImg)} // Fallback on error
          />
          {params.row.username}
        </div>
      );
    },
  },
  {
    field: "name",
    headerName: "Name",
    width: 200,
  },
  {
    field: "description",
    headerName: "Description",
    width: 250,
  },
  {
    field: "router_to",
    headerName: "Router",
    width: 200,
  },

];
